export default __webpack_public_path__ + "static/media/two.202febe1.jpg";